import ReactSwitch from 'react-switch';
import styled from 'styled-components';

// to overwrite react switch default style
export const Switch = styled(ReactSwitch)`
  opacity: 1 !important;

  &:focus {
    outline: 1px solid
      ${({ theme }) => theme.activeColorScheme.colors.backgroundPrimary};
  }
`;
